<template>
  <div class="mapPage">
    <div v-if="mapLevel === 2" class="back-box" @click="handleBack">返回上一级</div>
    <div id="dataScreenMap" v-loading="loading"></div>
  </div>
</template>

<script>
import { getFireMapPointDetail, getFireMapPoints } from "../../../../api/dataScreen";

export default {
  name: "TXMap",
  data() {
    return {
      loading: false,
      mapWarning: {},
      marker: null,
      markerDetail: null,
      mapLevel: 1
    }
  },
  mounted() {
    this.initMap()
  },
  beforeDestroy() {
    this.map.destroy();
  },
  methods: {
    initMap() {
      const center = new TMap.LatLng(39.302569, 116.694544)
      //定义map变量，调用 TMap.Map() 构造函数创建地图
      this.map = new TMap.Map(document.getElementById('dataScreenMap'), {
        center: center,//设置地图中心点坐标
        zoom: 10.8,   //设置地图缩放级别
      });
      this.getFireMapPoints()
    },
    getFireMapPoints() {
      this.mapLevel = 1
      getFireMapPoints().then(res => {
        this.mapWarning = res.data
        const xz_icon = require('../assets/xz-icon.png')
        const xz_w_icon = require('../assets/xz_w_icon.png')
        const townMap = [
          {name: "北史家务乡监测站点", value: [116.712914, 39.503905, this.mapWarning['001']], layer: '7', town: '001'},
          {name: "龙河高新区", value: [116.712914, 39.483905, this.mapWarning['002']], layer: '7', town: '002'},
          {name: "杨税务监测站点", value: [116.641846, 39.458728, this.mapWarning['003']], layer: '9', town: '003'},
          {name: "仇庄乡监测站点", value: [116.729050, 39.406038, this.mapWarning['005']], layer: '5', town: '005'},
          {name: "落垡镇监测站点", value: [116.791878, 39.427099, this.mapWarning['004']], layer: '10', town: '004'},
          {name: "码头镇监测站点", value: [116.793251, 39.315441, this.mapWarning['006']], layer: '3', town: '006'},
          {name: "调河头乡监测站点", value: [116.706905, 39.276251, this.mapWarning['009']], layer: '2', town: '009'},
          {name: "葛渔城镇监测站点", value: [116.802864, 39.241322, this.mapWarning['007']], layer: '4', town: '007'},
          {name: "东沽港镇监测站点", value: [116.808744, 39.176784, this.mapWarning['008']], layer: '6', town: '008'}
        ]
        const geometries = []
        townMap.forEach(item => {
          if (item.value[2] > 0) {
            geometries.push({
              styleId: 'wTown',
              position: new TMap.LatLng(item.value[1], item.value[0]),
              id: item.town,
              content: `${item.name}`
            })
          } else {
            geometries.push({
              styleId: 'Town',
              position: new TMap.LatLng(item.value[1], item.value[0]),
              id: item.town,
              content: `${item.name}`
            })
          }
        })
        this.marker = new TMap.MultiMarker({
          map: this.map,
          styles: {
            Town: new TMap.MarkerStyle({
              offset: {x: 0, y: 35},
              width: 35, // 宽度
              height: 40, // 高度
              src: xz_icon,
            }),
            wTown: new TMap.MarkerStyle({
              offset: {x: 0, y: 35},
              width: 35, // 宽度
              height: 40, // 高度
              src: xz_w_icon,
            }),
          },
          geometries: geometries
        });
        this.marker.on("click", (e) => {
          this.townMarkerClick(e)
        })
      })
    },
    removeMarker() {
      if (this.marker) {
        this.marker.setMap(null);
        this.marker = null;
      }
    },
    removeDetailMarker() {
      if (this.markerDetail) {
        this.markerDetail.setMap(null);
        this.markerDetail = null;
      }
    },
    townMarkerClick (evt) {
      getFireMapPointDetail({town: evt.geometry.id}).then(res => {
        this.removeMarker()
        this.map.setZoom(12);
        this.map.setCenter(evt.geometry.position)
        this.drawFireMarker(res.data)
      })
    },
    drawFireMarker (res) {
      this.mapLevel = 2
      const monitor_icon = require('../assets/monitor.png')
      const monitor_w_icon = require('../assets/monitor-warning.png')
      const fireIcon = require('../assets/fire.png')
      const geometries = []
      res.pointsInfo.forEach(item => {
        if(item.deviceStatus === 1) {
          geometries.push({
            styleId: 'monitor',
            position: new TMap.LatLng(Number(item.lat), Number(item.lng)),
            id: item.deviceSerial,
            content: `${item.pointName}`
          })
        } else {
          geometries.push({
            styleId: 'monitor_w',
            position: new TMap.LatLng(Number(item.lat), Number(item.lng)),
            id: item.deviceSerial,
            content: `${item.pointName}`
          })
        }
      })
      res.warningData.forEach(item => {
        geometries.push({
          styleId: 'fireIcon',
          position: new TMap.LatLng(Number(item.lat), Number(item.lng))
        })
      })
      this.markerDetail = new TMap.MultiMarker({
          map: this.map,
          styles: {
            monitor: new TMap.MarkerStyle({
              width: 26, // 宽度
              height: 26, // 高度
              offset: {x: 0, y: 26},
              src: monitor_icon,
            }),
            monitor_w: new TMap.MarkerStyle({
              width: 26, // 宽度
              height: 26, // 高度
              offset: {x: 0, y: 26},
              src: monitor_w_icon,
            }),
            fireIcon: new TMap.MarkerStyle({
              width: 26, // 宽度
              height: 26, // 高度
              src: fireIcon,
            })
          },
          geometries: geometries
        });
    },
    handleBack () {
      this.mapLevel = 1
      this.removeDetailMarker()
      this.map.setZoom(10.8)
      this.map.setCenter(new TMap.LatLng(39.302569, 116.694544))
      this.getFireMapPoints()
    }
  }
}
</script>

<style scoped lang="less">
.mapPage{
  width: 100%;
  height: 100%;
  position: relative;
  .back-box{
    position: absolute;
    top: 10px;
    left: 550px;
    width: 140px;
    height: 43px;
    background-image: url("../assets/back-box.png");
    background-size: 100% 100%;
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    text-align: center;
    line-height: 43px;
    cursor: pointer;
    z-index: 9999;
  }
  #dataScreenMap {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
}
</style>
